import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { signInWithEmailAndPassword, onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase/firebase';
import { doc, getDoc, getFirestore } from 'firebase/firestore';
import PostLoginPopup from '../components/PostLoginPopup';
import logo from '../assets/logo.png';
import './Login.css';

const db = getFirestore();

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [captchaAnswer, setCaptchaAnswer] = useState('');
  const [num1, setNum1] = useState(Math.floor(Math.random() * 10) + 1);
  const [num2, setNum2] = useState(Math.floor(Math.random() * 10) + 1);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [showSubscribePopup, setShowSubscribePopup] = useState(false);
  const [userEmail, setUserEmail] = useState('');
const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.state?.registered) {
      setSuccessMessage("🎉 Registered Successfully! Please login.");
    }
  }, [location]);

  const refreshCaptcha = () => {
    setNum1(Math.floor(Math.random() * 10) + 1);
    setNum2(Math.floor(Math.random() * 10) + 1);
    setCaptchaAnswer('');
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setError(null);
  setSuccessMessage(null);
  setLoading(true); // 🌀 Start spinner

  if (parseInt(captchaAnswer) !== num1 + num2) {
    setError('❌ Incorrect CAPTCHA ');
    setLoading(false); // ⛔ Stop spinner
    return;
  }

  try {
    await signInWithEmailAndPassword(auth, email, password);
  } catch (err) {
    setError('❌ Invalid email or password.');
    setLoading(false); // ⛔ Stop spinner on error
  }
};


  // ✅ Wait for auth state to load, then check Firestore
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const dismissed = localStorage.getItem('popup-dismissed');
        if (dismissed === 'true') return navigate('/');

        try {
          const docRef = doc(db, 'users', user.uid);
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
            const data = docSnap.data();
            if (!data.subscribed) {
              setUserEmail(user.email);
              setShowSubscribePopup(true); // ✅ Trigger popup
            } else {
              navigate('/');
            }
          } else {
            navigate('/');
          }
        } catch (err) {
          console.error("❌ Firestore read error:", err);
        }
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  return (
    <div className="login-container container mt-5">
      <div className="text-center mb-4">
        <img src={logo} alt="Logo" style={{ height: '100px', marginBottom: '20px' }} />
        <h1 className="display-5 text-primary fw-bold">KASHMIR JOBS</h1>
<p className="lead fw-bold">Login To Access Job Opportunities!</p>

      </div>

      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card shadow">
            <div className="card-body">
              <h3 className="card-title text-center mb-4">Login</h3>

              {successMessage && <div className="alert alert-success text-center">{successMessage}</div>}
              {error && <div className="alert alert-danger text-center">{error}</div>}

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label>Email</label>
                  <input
                    type="email"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label>Password</label>
                  <div className="input-group">
                    <input
                      type={showPassword ? 'text' : 'password'}
                      className="form-control"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? '🙈' : '👁️'}
                    </button>
                  </div>
                </div>

                <div className="mb-3">
                  <label>Solve to Login:</label>
                  <div className="captcha-group d-flex align-items-center gap-2">
                    <input type="text" value={num1} readOnly className="captcha-box" />
                    <span>+</span>
                    <input type="text" value={num2} readOnly className="captcha-box" />
                    <span>=</span>
                    <input
                      type="number"
                      value={captchaAnswer}
                      onChange={(e) => setCaptchaAnswer(e.target.value)}
                      required
                      placeholder="?"
                      className="captcha-input"
                    />
                    <button
                      type="button"
                      className="refresh-btn btn btn-sm btn-outline-primary"
                      onClick={refreshCaptcha}
                      title="Refresh CAPTCHA"
                    >
                      ↻
                    </button>
                  </div>
                </div>

                <div className="d-grid">
  <button className="btn btn-primary" type="submit" disabled={loading}>
    {loading ? (
      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    ) : (
      "Login"
    )}
  </button>
</div>
              </form>

<div className="text-center auth-links">
  <div className="register-link-text">
    <span>Don't have an account?</span>
    <Link to="/register"> Register here</Link>
  </div>
  <div className="forgot-password-text">
    <Link to="/forgot-password">Forgot password?</Link>
  </div>
</div>

            </div>
          </div>
        </div>
      </div>

      {showSubscribePopup && (
        <PostLoginPopup
          email={userEmail}
          onClose={() => {
            setShowSubscribePopup(false);
            navigate('/');
          }}
        />
      )}
    </div>
  );
};

export default Login;
